export const twoFactorUi = {
    en: {
        twoFactor: 'Two-factor authentication',
        twoFactorEnrolExplain: 'Your account requires two-factor authentication. Choose the app user that will receive your sign-in codes.',
        twoFactorRecipient: 'App user',
        twoFactorNoRecipients: 'There are no app users you can choose. Please contact your administrator.',
        twoFactorSendCode: 'Send code',
        twoFactorCodeSent: 'Enter the code sent to the app user.',
        twoFactorCode: 'Code',
        twoFactorVerify: 'Verify',
        twoFactorResend: 'Send a new code',
        twoFactorResendIn: 'Send a new code ({seconds}s)',
        twoFactorSubmitPassword: 'Submit password',
        twoFactorNowRequiredTitle: 'Two-factor authentication is now required',
        twoFactorNowRequiredBody: 'Your account does not have two-factor authentication yet. You will be asked to set it up the next time you sign in, or you can set it up now.',
        twoFactorSetUpNow: 'Set up now',
        twoFactorLater: 'Later',
        twoFactorCreateHint: 'Codes will be sent to this app user. The new admin confirms it with the first code at sign-in.',
        twoFactorPickRecipient: 'Choose the app user that will receive the codes',
        twoFactorCodeResent: 'A new code was sent.',
        twoFactorStartOver: 'Start over',
        twoFactorCancel: 'Cancel',
        twoFactorStatusOn: 'Enabled',
        twoFactorStatusOff: 'Not enabled',
        twoFactorRequiredByPolicy: 'Required by policy',
        twoFactorCurrentRecipient: 'Codes are sent to',
        twoFactorChangeRecipient: 'Change app user',
        twoFactorEnable: 'Enable two-factor authentication',
        twoFactorDisable: 'Disable two-factor authentication',
        twoFactorCannotDisable: 'Two-factor authentication is required by policy and cannot be disabled.',
        twoFactorPasswordPrompt: 'Confirm with your password',
        twoFactorReset: 'Reset two-factor authentication',
        twoFactorResetExplain: 'This removes the app user that receives this admin\'s codes and signs them out.',
        twoFactorResetDone: 'Two-factor authentication reset',
        adminOtpRequired: 'Require admin two-factor authentication',
        adminOtpLength: 'Admin code length',
        adminOtpTTL: 'Admin code validity (minutes)',
        adminOtpExclusive: 'Turn off public registration first',
        registrationExclusive: 'Turn off admin two-factor authentication first',
        teamAdminOtp: 'Admin two-factor authentication',
        teamAdminOtpInherit: 'Use the stack setting',
        teamAdminOtpRequired: 'Required',
        teamAdminOtpNotRequired: 'Not required',
        yupAdminOtpLength: 'Must be a whole number from 6 to 30',
        yupAdminOtpTTL: 'Must be a whole number from 1 to 60',
    },
    pt: {
        twoFactor: 'Autenticação de dois fatores',
        twoFactorEnrolExplain: 'Sua conta exige autenticação de dois fatores. Escolha o usuário do aplicativo que receberá seus códigos de acesso.',
        twoFactorRecipient: 'Usuário do aplicativo',
        twoFactorNoRecipients: 'Não há usuários do aplicativo disponíveis para escolha. Entre em contato com seu administrador.',
        twoFactorSendCode: 'Enviar código',
        twoFactorCodeSent: 'Digite o código enviado ao usuário do aplicativo.',
        twoFactorCode: 'Código',
        twoFactorVerify: 'Verificar',
        twoFactorResend: 'Enviar novo código',
        twoFactorResendIn: 'Enviar novo código ({seconds}s)',
        twoFactorSubmitPassword: 'Enviar senha',
        twoFactorNowRequiredTitle: 'A autenticação de dois fatores agora é obrigatória',
        twoFactorNowRequiredBody: 'Sua conta ainda não tem autenticação de dois fatores. Ela será solicitada no seu próximo acesso, ou você pode configurá-la agora.',
        twoFactorSetUpNow: 'Configurar agora',
        twoFactorLater: 'Depois',
        twoFactorCreateHint: 'Os códigos serão enviados para este usuário do aplicativo. O novo administrador confirma com o primeiro código no acesso.',
        twoFactorPickRecipient: 'Escolha o usuário do aplicativo que receberá os códigos',
        twoFactorCodeResent: 'Um novo código foi enviado.',
        twoFactorStartOver: 'Recomeçar',
        twoFactorCancel: 'Cancelar',
        twoFactorStatusOn: 'Ativada',
        twoFactorStatusOff: 'Não ativada',
        twoFactorRequiredByPolicy: 'Exigida pela política',
        twoFactorCurrentRecipient: 'Os códigos são enviados para',
        twoFactorChangeRecipient: 'Trocar usuário do aplicativo',
        twoFactorEnable: 'Ativar autenticação de dois fatores',
        twoFactorDisable: 'Desativar autenticação de dois fatores',
        twoFactorCannotDisable: 'A autenticação de dois fatores é exigida pela política e não pode ser desativada.',
        twoFactorPasswordPrompt: 'Confirme com sua senha',
        twoFactorReset: 'Redefinir autenticação de dois fatores',
        twoFactorResetExplain: 'Isso remove o usuário do aplicativo que recebe os códigos deste administrador e encerra as sessões dele.',
        twoFactorResetDone: 'Autenticação de dois fatores redefinida',
        adminOtpRequired: 'Exigir autenticação de dois fatores dos administradores',
        adminOtpLength: 'Tamanho do código de administrador',
        adminOtpTTL: 'Validade do código de administrador (minutos)',
        adminOtpExclusive: 'Desative primeiro o registro público',
        registrationExclusive: 'Desative primeiro a autenticação de dois fatores dos administradores',
        teamAdminOtp: 'Autenticação de dois fatores dos administradores',
        teamAdminOtpInherit: 'Usar a configuração geral',
        teamAdminOtpRequired: 'Exigida',
        teamAdminOtpNotRequired: 'Não exigida',
        yupAdminOtpLength: 'Deve ser um número inteiro de 6 a 30',
        yupAdminOtpTTL: 'Deve ser um número inteiro de 1 a 60',
    },
    es: {
        twoFactor: 'Autenticación de dos factores',
        twoFactorEnrolExplain: 'Su cuenta requiere autenticación de dos factores. Elija el usuario de la aplicación que recibirá sus códigos de acceso.',
        twoFactorRecipient: 'Usuario de la aplicación',
        twoFactorNoRecipients: 'No hay usuarios de la aplicación que pueda elegir. Contacte a su administrador.',
        twoFactorSendCode: 'Enviar código',
        twoFactorCodeSent: 'Introduzca el código enviado al usuario de la aplicación.',
        twoFactorCode: 'Código',
        twoFactorVerify: 'Verificar',
        twoFactorResend: 'Enviar un código nuevo',
        twoFactorResendIn: 'Enviar un código nuevo ({seconds}s)',
        twoFactorSubmitPassword: 'Enviar contraseña',
        twoFactorNowRequiredTitle: 'La autenticación de dos factores ahora es obligatoria',
        twoFactorNowRequiredBody: 'Su cuenta aún no tiene autenticación de dos factores. Se le pedirá configurarla en su próximo inicio de sesión, o puede configurarla ahora.',
        twoFactorSetUpNow: 'Configurar ahora',
        twoFactorLater: 'Más tarde',
        twoFactorCreateHint: 'Los códigos se enviarán a este usuario de la aplicación. El nuevo administrador lo confirma con el primer código al iniciar sesión.',
        twoFactorPickRecipient: 'Elija el usuario de la aplicación que recibirá los códigos',
        twoFactorCodeResent: 'Se envió un código nuevo.',
        twoFactorStartOver: 'Empezar de nuevo',
        twoFactorCancel: 'Cancelar',
        twoFactorStatusOn: 'Activada',
        twoFactorStatusOff: 'No activada',
        twoFactorRequiredByPolicy: 'Requerida por la política',
        twoFactorCurrentRecipient: 'Los códigos se envían a',
        twoFactorChangeRecipient: 'Cambiar usuario de la aplicación',
        twoFactorEnable: 'Activar autenticación de dos factores',
        twoFactorDisable: 'Desactivar autenticación de dos factores',
        twoFactorCannotDisable: 'La autenticación de dos factores es requerida por la política y no se puede desactivar.',
        twoFactorPasswordPrompt: 'Confirme con su contraseña',
        twoFactorReset: 'Restablecer autenticación de dos factores',
        twoFactorResetExplain: 'Esto elimina el usuario de la aplicación que recibe los códigos de este administrador y cierra sus sesiones.',
        twoFactorResetDone: 'Autenticación de dos factores restablecida',
        adminOtpRequired: 'Exigir autenticación de dos factores a los administradores',
        adminOtpLength: 'Longitud del código de administrador',
        adminOtpTTL: 'Validez del código de administrador (minutos)',
        adminOtpExclusive: 'Desactive primero el registro público',
        registrationExclusive: 'Desactive primero la autenticación de dos factores de los administradores',
        teamAdminOtp: 'Autenticación de dos factores de los administradores',
        teamAdminOtpInherit: 'Usar la configuración general',
        teamAdminOtpRequired: 'Requerida',
        teamAdminOtpNotRequired: 'No requerida',
        yupAdminOtpLength: 'Debe ser un número entero de 6 a 30',
        yupAdminOtpTTL: 'Debe ser un número entero de 1 a 60',
    },
    fr: {
        twoFactor: 'Authentification à deux facteurs',
        twoFactorEnrolExplain: 'Votre compte exige l\'authentification à deux facteurs. Choisissez l\'utilisateur de l\'application qui recevra vos codes de connexion.',
        twoFactorRecipient: 'Utilisateur de l\'application',
        twoFactorNoRecipients: 'Aucun utilisateur de l\'application ne peut être choisi. Veuillez contacter votre administrateur.',
        twoFactorSendCode: 'Envoyer le code',
        twoFactorCodeSent: 'Saisissez le code envoyé à l\'utilisateur de l\'application.',
        twoFactorCode: 'Code',
        twoFactorVerify: 'Vérifier',
        twoFactorResend: 'Envoyer un nouveau code',
        twoFactorResendIn: 'Envoyer un nouveau code ({seconds}s)',
        twoFactorSubmitPassword: 'Valider le mot de passe',
        twoFactorNowRequiredTitle: 'L\'authentification à deux facteurs est désormais obligatoire',
        twoFactorNowRequiredBody: 'Votre compte n\'a pas encore l\'authentification à deux facteurs. Elle vous sera demandée à votre prochaine connexion, ou vous pouvez la configurer maintenant.',
        twoFactorSetUpNow: 'Configurer maintenant',
        twoFactorLater: 'Plus tard',
        twoFactorCreateHint: 'Les codes seront envoyés à cet utilisateur de l\'application. Le nouvel administrateur le confirme avec le premier code lors de sa connexion.',
        twoFactorPickRecipient: 'Choisissez l\'utilisateur de l\'application qui recevra les codes',
        twoFactorCodeResent: 'Un nouveau code a été envoyé.',
        twoFactorStartOver: 'Recommencer',
        twoFactorCancel: 'Annuler',
        twoFactorStatusOn: 'Activée',
        twoFactorStatusOff: 'Non activée',
        twoFactorRequiredByPolicy: 'Exigée par la politique',
        twoFactorCurrentRecipient: 'Les codes sont envoyés à',
        twoFactorChangeRecipient: 'Changer d\'utilisateur de l\'application',
        twoFactorEnable: 'Activer l\'authentification à deux facteurs',
        twoFactorDisable: 'Désactiver l\'authentification à deux facteurs',
        twoFactorCannotDisable: 'L\'authentification à deux facteurs est exigée par la politique et ne peut pas être désactivée.',
        twoFactorPasswordPrompt: 'Confirmez avec votre mot de passe',
        twoFactorReset: 'Réinitialiser l\'authentification à deux facteurs',
        twoFactorResetExplain: 'Cela supprime l\'utilisateur de l\'application qui reçoit les codes de cet administrateur et ferme ses sessions.',
        twoFactorResetDone: 'Authentification à deux facteurs réinitialisée',
        adminOtpRequired: 'Exiger l\'authentification à deux facteurs des administrateurs',
        adminOtpLength: 'Longueur du code administrateur',
        adminOtpTTL: 'Validité du code administrateur (minutes)',
        adminOtpExclusive: 'Désactivez d\'abord l\'inscription publique',
        registrationExclusive: 'Désactivez d\'abord l\'authentification à deux facteurs des administrateurs',
        teamAdminOtp: 'Authentification à deux facteurs des administrateurs',
        teamAdminOtpInherit: 'Utiliser le paramètre général',
        teamAdminOtpRequired: 'Exigée',
        teamAdminOtpNotRequired: 'Non exigée',
        yupAdminOtpLength: 'Doit être un nombre entier de 6 à 30',
        yupAdminOtpTTL: 'Doit être un nombre entier de 1 à 60',
    },
};
